// extracted by mini-css-extract-plugin
export default {"root":"LinkPure_root__PrXNp"};